<p-chip
  [label]="label"
  [disabled]="disabled"
  [icon]="withIcon ? iconClass : ''"
  [removable]="withCloseIcon"
  removeIcon="ph ph-icon ph-x"
  [ngClass]="{ 'secondary': color === 'secondary' }"
/>
